var _defs, _path, _path2, _path3, _path4, _path5, _path6, _line, _line2, _line3, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaitingApproval(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#123c7f;}.cls-2,.cls-3{fill:none;stroke:#123c7f;stroke-width:4px;}.cls-2{stroke-linecap:round;stroke-linejoin:round;}.cls-3{stroke-miterlimit:10;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100,92.87c-6.61,0-13.22,0-19.84,0-1.68,0-3.27.14-3.21-2.37s1.67-2.32,3.33-2.32H120c1.62,0,3,0,3.06,2.31,0,2-1,2.41-2.67,2.4C113.59,92.84,106.8,92.87,100,92.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.73,21.5c.19.37.36.76.57,1.12,1.32,2.28.65,3.56-1.94,3.57q-18.9,0-37.8,0c-.84,0-1.68.08-2.52.12-1.68-.09-3.24-.19-3.06-2.61s1.87-2.17,3.47-2.17Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.13,62.27c-3-5.72-2.06-9.5,3.18-13.31.61-.45,1.22-.91,1.87-1.3,6.65-4,10.31-9.55,9.58-17.54-.05-.59,0-1.19,0-1.78,0-1.12.7-1.1,1.51-1.15s1.21.37,1.2,1.19,0,1.52,0,2.28c.48,7.87-2.89,13.71-9.39,17.93a50.05,50.05,0,0,0-4.13,3c-3.61,3-3.81,7.41-.37,10.55a47.28,47.28,0,0,0,5.1,3.77c7,4.81,9.57,11.56,8.82,19.82-.09.93-.34,1.36-1.36,1.35s-1.57-.39-1.43-1.5c0-.33,0-.68,0-1,.9-8.82-3.41-14.66-10.75-18.75l-2.87-2.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80,27.07c1.66-.08,2.39.55,2.2,2.36C81.36,38,85.4,43.88,92.56,48.19c5.7,3.43,6.92,6.76,5.33,12.48-.42.66-.84,1.32-1.25,2l-.47.49L94.7,64.48,91,67.19c-5.7,3.47-9,8.34-8.78,15.2,0,1.1,0,2.21,0,3.3S82,87.06,81,87s-1.38-.1-1.48-1.18C78.77,77.75,81.09,71,88,66.15c1.73-1.22,3.51-2.38,5.12-3.73,3.79-3.19,3.76-7.72,0-10.87a50.39,50.39,0,0,0-4.55-3.22c-7.54-4.94-9.78-12.14-8.88-20.68C79.63,27.44,79.89,27.26,80,27.07Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107,84.05l6,2.82H88.27c3.82-2,7.5-4.26,11.76-5.27.31.86.74,1.05,1.35.25l3.56,1.32A3.81,3.81,0,0,0,107,84.05Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100,53.58c-2-4.15-5.46-6.07-8.66-8.26a15.76,15.76,0,0,1-7-9.88c-.39-1.74-.27-2.58,1.93-2.55q13.72.18,27.44,0c1.93,0,2.31.6,2,2.33-.92,4.74-3.79,8-7.69,10.57C105,47.79,101.87,49.73,100,53.58Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 61.89,
    y1: 119.96,
    x2: 97.35,
    y2: 119.96
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 61.89,
    y1: 134.21,
    x2: 97.35,
    y2: 134.21
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 61.89,
    y1: 152.72,
    x2: 138.11,
    y2: 152.72
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.21,57.34h42.61a6.12,6.12,0,0,1,6.11,6.11V172.39a6.12,6.12,0,0,1-6.11,6.11H54.18a6.12,6.12,0,0,1-6.11-6.11V63.45a6.12,6.12,0,0,1,6.11-6.11H96.83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingApproval);
export default __webpack_public_path__ + "static/media/waiting-approval.f8ffa0e3456331fa21ef2eedc2668f89.svg";
export { ForwardRef as ReactComponent };